import { type UseQueryOptions, useQuery } from '@tanstack/react-query';
import type {
  ExternalWorkIntegrationStatusValues,
  WorkIntegrationResponse,
} from '@/common/api/types/workIntegrations';
import { associateById } from '@/common/utils/associateById';
import { WorkIntegrationsApi } from '@/features/settings/work-integrations/api/workIntegrations';
import { workIntegrationsQueryKeys } from '@/features/settings/work-integrations/queryKeys';

export const useGetAllWorkIntegrations = (
  queryOptions: Omit<UseQueryOptions<WorkIntegrationResponse[], Error>, 'queryFn' | 'queryKey'> & {
    onSuccess?: (data: WorkIntegrationResponse[]) => void;
  } = {},
  apiOptions?: {
    limit?: number;
    filter?: {
      statuses?: ExternalWorkIntegrationStatusValues[];
      ids?: number[];
      loopIds?: number[];
    };
  },
) => {
  return useQuery<WorkIntegrationResponse[], Error>({
    queryKey: workIntegrationsQueryKeys.workIntegrationsAll(apiOptions),
    queryFn: () => WorkIntegrationsApi.getAllWorkIntegrations(apiOptions),
    ...queryOptions,
  });
};

export const useGetAllWorkIntegrationsById = (
  queryOptions: Omit<
    UseQueryOptions<WorkIntegrationResponse[], Error, Record<number, WorkIntegrationResponse>>,
    'queryFn' | 'queryKey'
  > = {},
  apiOptions?: {
    limit?: number;
    filter?: {
      statuses?: ExternalWorkIntegrationStatusValues[];
      ids?: number[];
      loopIds?: number[];
    };
  },
) => {
  return useQuery<WorkIntegrationResponse[], Error, Record<number, WorkIntegrationResponse>>({
    queryKey: workIntegrationsQueryKeys.workIntegrationsAll(apiOptions),
    queryFn: () => WorkIntegrationsApi.getAllWorkIntegrations(apiOptions),
    ...queryOptions,
    select: associateById,
  });
};
